import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    pageWrapper: {
        width: "90%",
        margin: "0 auto",
    },
    // Single-row header matching the Corporations page (title + right-aligned control).
    headerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
    },
    // No margin override — uses the default h2 margins so spacing matches Corporations.
    title: {
        fontFamily: "Source Sans 3",
        fontSize: "32px",
        fontWeight: "600",
    },
    helperText: {
        fontFamily: "Source Sans 3",
        fontSize: "14px",
        color: theme.palette.text.secondary,
        margin: "0 0 16px",
    },
    errorText: {
        fontFamily: "Source Sans 3",
        fontSize: "14px",
        color: theme.palette.error.main,
        marginBottom: "12px",
    },
    search: {
        minWidth: "280px",
        background: "white",
    },
    // Modal body holding the per-key table.
    modalContent: {
        padding: "16px 32px",
        maxHeight: "65vh",
        overflowY: "auto",
    },
    modalSubtitle: {
        fontFamily: "Source Sans 3",
        fontSize: "14px",
        color: theme.palette.text.secondary,
        margin: "0 0 12px",
    },
    statusButton: {
        borderRadius: "16px",
        padding: "10px",
        background: "rgba(0, 0, 0, 0.08)",
    },
    statusRevoked: {
        borderRadius: "16px",
        padding: "10px",
        background: "rgba(211, 47, 47, 0.12)",
        color: theme.palette.error.main,
    },
    statusExpired: {
        borderRadius: "16px",
        padding: "10px",
        background: "rgba(237, 108, 2, 0.12)",
        color: theme.palette.warning.main,
    },
    tableRow: {
        "&:hover": {
            cursor: "default",
        },
    },
}));
